import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import { colorsModeUI } from '../../../modeUI';
import './index.css';

/**
 * UIMessage
 */
export default class UiMenuItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleHover = this.toggleHover.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * Toggle hover
   */
  toggleHover() {
    const { hover } = this.state;
    this.setState({ hover: !hover });
  }

  render() {
    const { label, onClick, mode } = this.props;
    const { hover } = this.state;
    const style = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      style.color = hover
        ? colors.MENU_ITEM_ACTIVE_COLOR
        : colors.MENU_ITEM_COLOR;
    }
    return (
      <Menu.Item
        name={label}
        content={label}
        onClick={() => onClick()}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
        style={style}
      />
    );
  }
}

UiMenuItem.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  mode: PropTypes.string,
};

UiMenuItem.defaultProps = {
  label: '',
  onClick: () => {},
  mode: null,
};
